import DashboardCard from "../../../ui/DashboardCard/DashboardCard";
import type { TeenDashboardUpcomingGigItemResponse } from "../../../../types/teenDashboardTypes";
import { formatCityStateZip } from "../../../../utils/LocationUtils";
import { toCurrency, toReadableGigDateTime } from "../shared/dashboardDisplay";

type TeenUpcomingGigsBoxProps = {
  gigs: TeenDashboardUpcomingGigItemResponse[];
  loading: boolean;
};

const TeenUpcomingGigsBox = ({ gigs, loading }: TeenUpcomingGigsBoxProps) => {
  return (
    <DashboardCard title="Scheduled Gigs Awaiting Completion" subtitle="Accepted gigs waiting on completion." to="/teen/scheduled-gigs">
      {loading ? (
        <p className="text-sm text-myteengig-text-muted">Loading upcoming gigs...</p>
      ) : gigs.length === 0 ? (
        <p className="text-sm text-myteengig-text-muted">No upcoming confirmed gigs.</p>
      ) : (
        <ul className="space-y-2 sm:space-y-3">
          {gigs.map((gig) => (
            <li key={gig.gigRequestId} className="rounded-lg border border-myteengig-border bg-myteengig-background p-2.5 sm:p-3">
              <div className="flex items-start justify-between gap-2">
                <p className="min-w-0 text-sm font-semibold leading-5 text-myteengig-text-primary sm:text-base">{gig.gigTitle ?? "Untitled Gig"}</p>
                <span className="shrink-0 text-sm font-semibold leading-5 text-myteengig-primary">{toCurrency(gig.paymentAmountCents, gig.volunteer)}</span>
              </div>
              <p className="mt-1 text-xs leading-5 text-myteengig-text-muted sm:text-sm">{toReadableGigDateTime(gig.confirmedStartTime, gig.gigTimeZone)}</p>
              <p className="text-xs leading-5 text-myteengig-text-muted sm:mt-1 sm:text-sm">{formatCityStateZip(gig)}</p>
            </li>
          ))}
        </ul>
      )}
    </DashboardCard>
  );
};

export default TeenUpcomingGigsBox;
